export const USER_GROUP = {
  biggerFirstPackage: import.meta.env.VITE_APP_USER_GROUP_BIGGER_FIRST_PACKAGE,
};
